import { createTheme } from '@mui/material/styles';

const lightTheme = {
  mode: 'light',
  primary: {
    main: '#1E3A5F',
    light: '#4A6D8C',
    secondary: '#F28C28',
    ultraLight: '#EAF0F8',
  },
  background: {
    default: '#EEF2F8',
    secondary: '#D1D1D1',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#1E3A5F',
    secondary: '#4A4A4A',
  },
  sidebar: {
    primary: '#1E3A5F',
    secondary: '#4A6D8C',
    text: '#1E3A5F',
  },
  avatar: {
    background: '#1E3A5F',
    color: '#FFFFFF',
  },
};

const darkTheme = {
  mode: 'dark',
  primary: {
    main: '#4A6D8C',
    light: '#6B8CAA',
    secondary: '#F9A55A',
    ultraLight: '#2C3E50',
  },
  background: {
    default: '#121212',
    secondary: '#1E1E1E',
    paper: '#242424',
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#D7D7D7',
  },
  sidebar: {
    primary: '#2C3E50',
    secondary: '#6B8CAA',
    text: '#D7D7D7',
  },
  avatar: {
    background: '#1E3A5F',
    color: '#FFFFFF',
  },
};

export const getDesignTokens = (mode) => ({
  palette: mode === 'light' ? lightTheme : darkTheme,
  typography: {
    fontFamily: 'Inter, ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji',
    // fontFamily: "'Roboto', sans-serif",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          transition: 'background-color 0.3s ease, color 0.3s ease',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          transition: 'background-color 0.3s ease, color 0.3s ease',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          transition: 'background-color 0.3s ease, color 0.3s ease',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          transition: 'background-color 0.3s ease, color 0.3s ease',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          transition: 'background-color 0.3s ease',
        },
      },
    },
  },
});

const theme = createTheme(getDesignTokens('light'));

export default theme;
